<template>
    <div>
        <p>Petit</p>

        <p>Texte</p>

        <b-textarea v-model="text_small"></b-textarea>

        <p>Type de bouton</p>

		<b-form-select v-model="type_button_small" :options="['', 'link', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']"/>

        <p>Texte du bouton</p>

        <b-input v-model="text_button_small"></b-input>

        <hr />

        <p>Grand</p>

        <p>Texte</p> 

        <b-textarea v-model="text_big"></b-textarea>

        <p>Type de bouton</p>

		<b-form-select v-model="type_button_big" :options="['', 'link', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']"/>

        <p>Texte du bouton</p>

        <b-input v-model="text_button_big"></b-input>

        <hr />

        <p>Action</p>

        <ace_editor :code="code" @update="update_code($event)"></ace_editor>

        <p>Base de données - colonnes mises à jour</p>

        <array_editor ref="array_editor" :start_data="columns_db" @update="update_columns_db($event)"></array_editor>

        <p>Projet</p>

        <b-select v-model="project" :options="projects_options"/>
    </div>

</template>

<script>
	import projects from "../../services/projects.js";
	import array_editor from "../array_editor.vue";
	import ace_editor from "../ace_editor.vue";

    export default {
        components: {
            ace_editor,
            array_editor
        },
        props: {
            params: {}
        },
        data: function () {
            return {
                text_small: "",
                type_button_small: "",
                text_button_small: "",
                text_big: "",
                type_button_big: "",
                text_button_big: "",
                code: "",
                columns_db: [],
                project: "",
                projects_options: [""]
            };
		},
		methods: {
            async update_code(data)
			{
				this.code = data;
			},
            async update_columns_db(data)
			{
				this.columns_db = data;
			},
            async save()
            {
                return {
                    text_small: this.text_small,
                    type_button_small: this.type_button_small,
                    text_button_small: this.text_button_small,
                    text_big: this.text_big,
                    type_button_big: this.type_button_big,
                    text_button_big: this.text_button_big,
                    code: this.code,
                    columns_db: this.columns_db,
                    project: this.project
                }
            },
            async load(data)
            {
                this.text_small = data.text_small;
                this.type_button_small = data.type_button_small;
                this.text_button_small = data.text_button_small;
                this.text_big = data.text_big;
                this.type_button_big = data.type_button_big;
                this.text_button_big = data.text_button_big;
                this.code = data.code;
                this.columns_db = data.columns_db;
                this.project = data.project;

                if (this.columns_db)
                    this.$refs.array_editor.load(this.columns_db);
            }
		},
		mounted: async function () {
            if (this.params)
                this.load(this.params);

            this.projects = await projects.getAll();
			for (var i = 0; i < this.projects.length; i++) {
				this.projects_options.push({
					value: this.projects[i].uid,
					text: this.projects[i].libelle
				})
			}

		},
    }


</script>